(() => {
  const formatDate = (date) =>
    new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: '2-digit',
    }).format(date);

  const updateDeliveryWindow = (el) => {
    if (!(el instanceof HTMLElement)) return;
    const textEl = el.querySelector('[data-delivery-window-text]');
    if (!textEl) return;

    const prefix = (el.dataset.deliveryPrefix || 'Estimated delivery').trim();
    const minDays = parseInt(el.dataset.deliveryMinDays || '6', 10);
    const maxDays = parseInt(el.dataset.deliveryMaxDays || '10', 10);
    const safeMin = Number.isFinite(minDays) ? Math.max(0, minDays) : 6;
    const safeMax = Number.isFinite(maxDays) ? Math.max(safeMin, maxDays) : Math.max(safeMin, 10);

    const now = new Date();
    const start = new Date(now);
    const end = new Date(now);
    start.setDate(now.getDate() + safeMin);
    end.setDate(now.getDate() + safeMax);

    textEl.textContent = `${prefix}: ${formatDate(start)} - ${formatDate(end)}`;
  };

  const updateAll = (scope = document) => {
    scope.querySelectorAll('[data-delivery-window]').forEach(updateDeliveryWindow);
  };

  document.addEventListener('DOMContentLoaded', () => updateAll(document));
  document.addEventListener('product-info:loaded', (event) => {
    if (event.target instanceof HTMLElement) updateAll(event.target);
  });
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) updateAll(event.target);
  });
})();
